import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { CustomValidator } from '../classes/CustomValidator';
import { CustomValidatorKey } from '../enums/CustomValidatorKey';

export class MinValueValidator extends CustomValidator {
    key = CustomValidatorKey.MIN_VALUE;

    constructor(private minValue: number) {
        super();
    }

    validatorFunction(control: AbstractControl): ValidationErrors {
        return Validators.min(this.minValue)(control);
    }
}
